export default __webpack_public_path__ + "static/media/aquasil-ultra-impregum.261eb766.png";